import ActionTypes from '../actions/types';
import { defaultState } from './defaultState';
import { setObjectToState, setState } from './helper';

const initialState = defaultState.map;

export default (state = initialState, action) => {
  const {type, zoomLevel, position} = action;

  switch (type) {
    case ActionTypes.MAP_SET_GEOGRAPHY:
      return setObjectToState(state, { zoomLevel, position });

    case ActionTypes.MAP_ZOOM_IN:
      return setState(state, action, 'zoomLevel');

    case ActionTypes.UPDATE_MAP_POSITION:
      return setState(state, action, 'position');

    case ActionTypes.RESET_MAP:
      return initialState;

    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/reducers/mapReducer.js